import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { IProjectSubmissionStudentNameTransfer } from "../../repositories/model/transfer/IProjectSubmissionStudentNameTransfer";


const AuthTokenStorageKey = "_BASIC_AUTHENTICATION_TOKEN_";

export default class AssignedStudentsNameProvider {
	constructor() {}

	public async getStudentNames(projectCode: string): Promise<IProjectSubmissionStudentNameTransfer[]> {
		const token = localStorage.getItem(AuthTokenStorageKey);
		const headers: Record<string, string> = {};
		if (token) headers["X-Auth-Token"] = token;

		const url = `/api/v1/projects/${encodeURIComponent(projectCode)}/submissions/studentNames`;
		const config: AxiosRequestConfig = {
			method: "get",
			url,
			headers,
			responseType: "json",
		};

		const response = await axios.request<IProjectSubmissionStudentNameTransfer[], AxiosResponse<IProjectSubmissionStudentNameTransfer[]>>(config);


		// sort the response
		const sorted = response.data.sort((a, b) => {
			if (a.school < b.school) return -1;
			if (a.school > b.school) return 1;
			if (a.grade < b.grade) return -1;
			if (a.grade > b.grade) return 1;
			if (a.className < b.className) return -1;
			if (a.className > b.className) return 1;
			if (a.number < b.number) return -1;
			if (a.number > b.number) return 1;
	
			if (a.name < b.name) return -1;
			if (a.name > b.name) return 1;
	
			return 0;
		});
		
		return sorted;
	}
}
